import { useParams } from "react-router-dom"
import { useGetMe } from "../../../store/useGetMe"

export const useIsOwnBusiness = () => {
  const { handle: urlHandle } = useParams<{ handle: string }>()
  const { myBusiness, loading } = useGetMe()
  const isOwnBusiness = urlHandle && urlHandle === myBusiness.handle
  return { isOwnBusiness, loading }
}
